
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/generated-templates/directory-images-template-page",
      function () {
        return require("private-next-pages/generated-templates/directory-images-template-page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/generated-templates/directory-images-template-page"])
      });
    }
  